import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Tenant, TenantLink } from "@shared/modules/tenants";
import { api } from "../../../core/lib/api";

interface TenantState {
  currentTenantId: string | null;
  available: Tenant[];
  links: TenantLink[];
  setTenant: (id: string) => void;
  load: () => Promise<void>;
}

/** Établissement courant (persisté) + liste accessible au compte connecté. */
export const useTenantStore = create<TenantState>()(
  persist(
    (set) => ({
      currentTenantId: null,
      available: [],
      links: [],
      setTenant: (id) => set({ currentTenantId: id }),
      load: async () => {
        const [list, links] = await Promise.all([api<Tenant[]>("/api/tenants"), api<TenantLink[]>("/api/tenants/mine")]);
        set((s) => ({
          available: list,
          links,
          // La sélection persistée peut viser un établissement inaccessible à ce
          // compte (autre session sur le même navigateur) : on retombe sur le premier.
          currentTenantId:
            s.currentTenantId && list.some((t) => t.id === s.currentTenantId)
              ? s.currentTenantId
              : (list[0]?.id ?? null),
        }));
      },
    }),
    { name: "bp-tenant", partialize: (s) => ({ currentTenantId: s.currentTenantId }) },
  ),
);
